/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Abandon_BtnInputs */



/**
* | output |
* | --- |
* | "Abandon" |
*
* @param {Profile_Abandon_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_abandon_btn = /** @type {((inputs?: Profile_Abandon_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Abandon_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abandonner")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abandonar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Abandonar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abbandona")
	return /** @type {LocalizedString} */ ("Abandon")
});